import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux'
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import './assets/globalCss/theme.css';
import './App.css';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import PublicRoutes from './routes/PublicRoutes';
import Navigation from './components/navigations/navigation.component';
import Footer from './components/footer/footer.component';
import { getAll } from './actions/allActions'
import ScrollToTop from './components/navigations/ScrollToTop';

function App() {

  const dispatch = useDispatch()
  const arr = [
    { name: 'sani', roll: 14 },
    { name: 'akash', roll: 20 },
  ]

  const a = new URLSearchParams(JSON.stringify(arr))
  console.log('aaad:', a)

  useEffect(() => {
    dispatch(getAll())
  }, [dispatch])

  return (
    <Router>
      <ScrollToTop />
      <Navigation />
      <Route path='/' component={PublicRoutes} />
      <Footer />
    </Router>
    // <div className="App">
    //   <header className="App-header">
    //     <img src={logo} className="App-logo" alt="logo" />
    //     <p>
    //       Edit <code>src/App.js</code> and save to reload.
    //     </p>
    //     <a
    //       className="App-link"
    //       href="https://reactjs.org"
    //       target="_blank"
    //       rel="noopener noreferrer"
    //     >
    //       Learn React
    //     </a>
    //   </header>
    // </div>
  );
}

export default App;
